module.exports = __webpack_public_path__ + "static/media/17_tn.8147421a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/borders/thumbnails/17_tn.jpg
// module id = 653
// module chunks = 0